import React, { Component } from 'react';
import styled from 'styled-components';
import * as variables from '../../styles/variables'
import Button from './Button'
import classNames from 'classnames'

const Wrap = styled.div`
  background-color: ${variables.colours.lightGrey};
  margin: 0px 0px 20px;
  border-radius: 5px;
`

const ChildrenWrapper = styled.div`
  display: none;
  padding: 10px 15px;

  &.show {
    display: block;
  }
`

const Title = styled.h2`
  font-size: 20px;
  // font-weight: bold;
  font-family: ${variables.fonts.body};
`

const NewText = styled.span`
  margin-left: 0.5em;
  color: ${variables.colours.primary};
  font-style: italic;
  text-transform: uppercase;
  font-size: 17px;
  letter-spacing: .5px;
`

const Header = styled.div`
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  &:hover {
    background-color: lighten(${variables.colours.lightGrey}, 40%);
  }
  // span {
  //   color: black;
  //   text-decoration: underline;
  // }
`

class CollapsiblePanel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render() {
    const { title, newText, showPrompt, hidePrompt } = this.props
    const { isOpen } = this.state
    return (
      <Wrap {...this.props} title="">
        <Header onClick={this.toggle} >
          <Title style={{'margin': '10px 0px'}}>
            {title}
            {newText && <NewText>{newText}</NewText>}
          </Title>
          <Button type="button" secondary="true" small="true" style={{'marginRight': '0'}}>{isOpen ? hidePrompt : showPrompt}</Button>
        </Header>
        <ChildrenWrapper className={classNames({show: isOpen})} >
          {this.props.children}
        </ChildrenWrapper>
      </Wrap>
    )
  }
}

export default CollapsiblePanel